<template>
  <div>
    <cadastro-base :salvar="salvar">
      <template slot="conteudo">
        <b-row>
          <b-form-group
            label="Nome"
            class="col-md-12"
          >
            <validation-provider
              #default="{ errors }"
              rules="required"
              name="Nome"
            >
              <b-form-input
                v-model="form.nome"
                :state="errors.length > 0 ? false:null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-row>
        <b-row>
          <b-form-group
            label="Descrição (opcional)"
            class="col-12"
          >
            <b-textarea v-model="form.descricao" />
          </b-form-group>
        </b-row>
        <b-row>
          <b-col
            cols="2"
            style="padding-left: 5px;"
          >
            <b-form-checkbox
              v-model="form.simplesNacional"
              :value="true"
              :unchecked-value="false"
              style="margin-top: 0.7rem"
              @change="mudarTributacaoSN($event)"
            >
              Simples Nacional
            </b-form-checkbox>
          </b-col>
          <b-col
            cols="1"
            style="padding-left: 5px;"
          >
            <b-form-checkbox
              v-model="form.mei"
              :value="true"
              :unchecked-value="false"
              style="margin-top: 0.7rem"
              @change="mudarTributacaoMEI($event)"
            >
              MEI
            </b-form-checkbox>
          </b-col>
          <b-col
            cols="2"
            style="padding-left: 5px;"
          >
            <b-form-checkbox
              v-model="form.recursosHumanos"
              :value="true"
              :unchecked-value="false"
              style="margin-top: 0.7rem"
              @change="mudarTributacaoRH($event)"
            >
              Recursos Humanos
            </b-form-checkbox>
          </b-col>
          <b-col
            cols="2"
            style="padding-left: 5px;"
          >
            <b-form-checkbox
              v-model="form.consultoria"
              :value="true"
              :unchecked-value="false"
              style="margin-top: 0.7rem"
              @change="mudarTributacaoConsultoria($event)"
            >
              Consultoria
            </b-form-checkbox>
          </b-col>
          <b-col
            cols="2"
            style="padding-left: 5px;"
          >
            <b-form-checkbox
              v-model="form.domestica"
              :value="true"
              :unchecked-value="false"
              style="margin-top: 0.7rem"
              @change="mudarTributacaoDomestica($event)"
            >
              Doméstica
            </b-form-checkbox>
          </b-col>
        </b-row>
      </template>
    </cadastro-base>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import {
  required,
} from '@validations'
import CadastroBase from '@/shared/components/cadastro-base/CadastroBase.vue'
import api from '@/app-modulo/comercial/tipo-tributacao/shared/services/api'

export default {
  name: 'TipoTributacao',
  components: {
    ValidationProvider,
    CadastroBase,
  },
  data() {
    return {
      required,
      form: {
        nome: '',
        descricao: '',
        simplesNacional: false,
      },
      sobrescreveSN: false,
      sobrescreveMEI: false,
      sobrescreveRH: false,
      sobrescreveConsultoria: false,
      sobrescreveDomestica: false,
    }
  },
  created() {
    this.state = this.$route.path.indexOf('editar') > 0 ? 'editar' : 'novo'
    if (this.state === 'editar') {
      this.carregar(this.$route.params.id)
    }
  },
  methods: {
    carregar(id) {
      api.getTipoTributacao(id)
        .then(payload => {
          this.form = payload.data
        })
    },
    salvar() {
      return new Promise((resolve, reject) => {
        if (this.state === 'novo') {
          api.createTipoTributacao(this.form, this.sobrescreveSN, this.sobrescreveMEI, this.sobrescreveRH, this.sobrescreveConsultoria, this.sobrescreveDomestica)
            .then(() => {
              this.$router.go(-1)
              resolve('Tipo de tributação cadastrado com sucesso')
            })
            .catch(err => {
              reject(err)
            })
        } else {
          api.updateTipoTributacao(this.form.id, this.form, this.sobrescreveSN, this.sobrescreveMEI, this.sobrescreveRH, this.sobrescreveConsultoria, this.sobrescreveDomestica)
            .then(() => {
              this.$router.go(-1)
              resolve('Tipo de tributação alterada com sucesso')
            })
            .catch(err => {
              reject(err)
            })
        }
      })
    },
    cancelar() {
      this.$router.go(-1)
    },

    mudarTributacaoSN(check) {
      if (check) {
        this.$set(this.form, 'mei', false)
        this.$set(this.form, 'recursosHumanos', false)
        this.$set(this.form, 'consultoria', false)
        this.$set(this.form, 'domestica', false)
        this.sobrescreveMEI = false
        this.sobrescreveRH = false
        this.sobrescreveDomestica = false
        this.sobrescreveConsultoria = false

        this.verificaTributacaoExiste('SimplesNacional', 'Simples Nacional')
      } else {
        this.sobrescreveSN = false
      }
    },

    mudarTributacaoMEI(check) {
      if (check) {
        this.$set(this.form, 'recursosHumanos', false)
        this.$set(this.form, 'simplesNacional', false)
        this.$set(this.form, 'consultoria', false)
        this.$set(this.form, 'domestica', false)
        this.sobrescreveSN = false
        this.sobrescreveRH = false
        this.sobrescreveDomestica = false
        this.sobrescreveConsultoria = false

        this.verificaTributacaoExiste('Mei', 'MEI')
      } else {
        this.sobrescreveMEI = false
      }
    },

    mudarTributacaoRH(check) {
      if (check) {
        this.$set(this.form, 'mei', false)
        this.$set(this.form, 'simplesNacional', false)
        this.$set(this.form, 'consultoria', false)
        this.$set(this.form, 'domestica', false)
        this.sobrescreveSN = false
        this.sobrescreveMEI = false
        this.sobrescreveDomestica = false
        this.sobrescreveConsultoria = false

        this.verificaTributacaoExiste('RecursosHumanos', 'Recursos Humanos')
      } else {
        this.sobrescreveRH = false
      }
    },

    mudarTributacaoConsultoria(check) {
      if (check) {
        this.$set(this.form, 'mei', false)
        this.$set(this.form, 'simplesNacional', false)
        this.$set(this.form, 'domestica', false)
        this.$set(this.form, 'recursosHumanos', false)
        this.sobrescreveRH = false
        this.sobrescreveSN = false
        this.sobrescreveMEI = false
        this.sobrescreveDomestica = false

        this.verificaTributacaoExiste('Consultoria', 'Consultoria')
      } else {
        this.sobrescreveConsultoria = false
      }
    },

    mudarTributacaoDomestica(check) {
      if (check) {
        this.$set(this.form, 'mei', false)
        this.$set(this.form, 'simplesNacional', false)
        this.$set(this.form, 'consultoria', false)
        this.$set(this.form, 'recursosHumanos', false)
        this.sobrescreveConsultoria = false
        this.sobrescreveRH = false
        this.sobrescreveSN = false
        this.sobrescreveMEI = false

        this.verificaTributacaoExiste('Domestica', 'Domestica')
      } else {
        this.sobrescreveDomestica = false
      }
    },

    verificaTributacaoExiste(tipo, tipoMostrar) {
      const tributacaoId = this.form.id ? this.form.id : 0

      api.verificaTributacoesExistente(tributacaoId, tipo)
        .then(payload => {
          if (payload.data && (this.form.simplesNacional || this.form.recursosHumanos || this.form.mei || this.form.consultoria || this.form.domestica)) {
            this.$swal({
              title: `Deseja marcar como ${tipoMostrar}?`,
              text: 'A ação irá sobrescrever a tributação já existente com essa configuração.',
              confirmButtonText: 'Sim',
              cancelButtonText: 'Não',
              showCancelButton: true,
              focusConfirm: false,
              type: 'question',
              customClass: {
                confirmButton: 'mr-1 w-25 btn-primary',
                cancelButton: 'w-25 btn-danger',
              },
            })
              .then(result => {
                if (tipo === 'SimplesNacional') {
                  this.sobrescreveSN = result.value
                  this.form.simplesNacional = result.value
                } else if (tipo === 'Mei') {
                  this.sobrescreveMEI = result.value
                  this.form.mei = result.value
                } else if (tipo === 'RecursosHumanos') {
                  this.sobrescreveRH = result.value
                  this.form.recursosHumanos = result.value
                } else if (tipo === 'Consultoria') {
                  this.sobrescreveConsultoria = result.value
                  this.form.consultoria = result.value
                } else if (tipo === 'Domestica') {
                  this.sobrescreveDomestica = result.value
                  this.form.domestica = result.value
                }
              })
          }
        })
    },
  },
}
</script>
